module.exports = __webpack_public_path__ + "img/Transforme_en_France.c43c0d8f.png";